module.exports = __webpack_public_path__ + "img/register.e09719b4.png";